import {Routes} from "@angular/router";
import {MsalGuard} from "@azure/msal-angular";

export const routes: Routes = [
  {
    path: "data-product/:name/:id",
    loadComponent: () => import("./product/product.component").then((m) => m.ProductComponent),
    canActivate: [MsalGuard],
  }, // Route to the data products
  {
    path: "product/:name/:id",
    loadComponent: () => import("./product/product.component").then((m) => m.ProductComponent),
    canActivate: [MsalGuard],
  }, // Route to the products
  {
    path: "enabler-project/:name/:id",
    loadComponent: () => import("./enabler/enabler-project.component").then((m) => m.EnablerProjectComponent),
    canActivate: [MsalGuard],
  }, // Route to the enabler project
  {
    path: "portfolio-review/:type/:name",
    loadComponent: () => import("./portfolio-review/portfolio-review.component").then((m) => m.PortfolioReviewComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "search",
    loadComponent: () => import("./header/search-page/search-page.component").then((m) => m.SearchPageComponent),
    canActivate: [MsalGuard],
  }, // Add Search Component
  {
    path: "monitoring/:type",
    loadComponent: () => import("./monitoring/monitoring.component").then((m) => m.MonitoringComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "program-roadmap-preparation",
    loadComponent: () => import("./roadmap-preparation/program-roadmap-preparation/program-roadmap-preparation.component").then((m) => m.ProgramRoadmapPreparationComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "lbu-roadmap-preparation",
    loadComponent: () => import("./roadmap-preparation/lbu-roadmap-preparation/lbu-roadmap-preparation.component").then((m) => m.LbuRoadmapPreparationComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "program/:id",
    loadComponent: () => import("./program/program.component").then((m) => m.ProgramComponent),
    canActivate: [MsalGuard],
  },
    {
    path: "enabler/:name/:id",
    loadComponent: () => import("./enabler/enabler.component").then((m) => m.EnablerComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "digital-line",
    loadComponent: () => import("./digital-line/digital-line.component").then((m) => m.DigitalLineComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "help",
    loadComponent: () => import("./header/help/help.component").then((m) => m.HelpComponent),
    canActivate: [MsalGuard],
  }, // Route to the help page
  {
    path: "rights-management",
    loadComponent: () => import("./rights-management/rights-management.component").then((m) => m.RightsManagementComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "admin-panel",
    loadComponent: () => import("./admin-panel/admin-panel.component").then((m) => m.AdminPanelComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "",
    redirectTo: "",
    pathMatch: "full",
    canActivate: [MsalGuard],
  }, // Redirect to the default product
  {path: "**", redirectTo: "", canActivate: [MsalGuard]}, // Manage route not founds
];
